import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ErrorMessage, Field } from "formik";

import {acceptPersonalTerms, acceptConsentInformation } from "../../reducers/simpleAction";

class AcceptTermsCard extends Component {

    acceptPersonalTerms(bool) {
      this.props.acceptPersonalTerms({ bool });
      this.props.setFieldValue("personalTermsAccepted", bool);
    }

    acceptConsentInformation(bool) {
      this.props.acceptConsentInformation({ bool });
      this.props.setFieldValue("consentInformationAccepted", bool)
    }
    
    render() {
        return (
          <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Bekräfta dina uppgifter</label>
                  <div className="custom-control custom-checkbox mr-1">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      onChange={() => this.acceptPersonalTerms(!this.personalTermsAccepted) }
                      id="checkboxUserConfirmed"
                      checked={this.personalTermsAccepted}
                    />
                    <label className="custom-control-label" htmlFor="checkboxUserConfirmed" >
                      Jag bekräftar att de uppgifter jag angivit är korrekta och att jag tagit del av ovanstående information
                    </label>
                    <Field name="personalTermsAccepted" type="hidden" className={ "form-control" + (this.props.errors.personalTermsAccepted && this.props.touched.personalTermsAccepted ? " is-invalid" : "") } />
                    <ErrorMessage name="personalTermsAccepted" component="div" className="invalid-feedback" />
                  </div>
                </div>

                <hr />
                
                <div className="form-group">
                  <p>{this.props.consentInformation}</p>
                  <div className="custom-control custom-checkbox mr-1">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      onChange={() => this.acceptConsentInformation(!this.consentInformationAccepted) }
                      id="checkboxConsentInformation"
                      checked={this.consentInformationAccepted}
                    />
                    <label className="custom-control-label" htmlFor="checkboxConsentInformation" >
                      {this.props.consentCheckboxInformation}
                    </label>
                    <Field name="consentInformationAccepted" type="hidden" className={ "form-control" + (this.props.errors.consentInformationAccepted && this.props.touched.consentInformationAccepted ? " is-invalid" : "") } />
                    <ErrorMessage name="consentInformationAccepted" component="div" className="invalid-feedback" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
      personalTermsAccepted: state.simpleReducer.personal_terms_accepted,
      consentInformationAccepted: state.simpleReducer.consent_information_accepted,
      consentInformation: state.simpleReducer.textSections.consentInformation,
      consentCheckboxInformation: state.simpleReducer.textSections.consentCheckboxInformation,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    acceptPersonalTerms: bindActionCreators(acceptPersonalTerms, dispatch),
    acceptConsentInformation: bindActionCreators(acceptConsentInformation, dispatch)
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AcceptTermsCard);
